export const caseSections = [
    {
        id: 1,
        name: 'Летние Кейсы',
        caseIds: [1, 2, 3, 4, 5]
    },
    {
        id: 2,
        name: 'Бесплатные Кейсы',
        caseIds: [6, 7, 8, 9, 10]
    },
    {
        id: 3,
        name: 'Лимитированные Кейсы',
        caseIds: [11, 12, 15]
    },
    {
        id: 4,
        name: 'Наши Кейсы',
        caseIds: [21]
    },
];